<template>
  <div class="a4-page">
    <spacer :y="3"/>
    <div :class="$style.wrapper">
      <div v-if="user">
        <h1 :class="$style.c">【マイページへのログイン】</h1>
        <spacer :y="2"/>
        <p>{{ user.username }} 様（{{ user.school_year }}年）</p>
        <spacer :y="2"/>
        <p>本校では、他校に先駆け、昨年9月よりオンラインでココロの専門家に相談する「Welcome to talkスクールメンタルヘルスケア（ココモニボイス、テキスト健康相談、オンライン健康相談）」サービスを導入しました。</p>
        <spacer :y="2"/>
        <p>臨床経験豊富な専門家スタッフ （現役の精神科医・臨床心理士・公認心理師）が 一人ひとりの不安や悩みに寄り添います。</p>
        <spacer :y="2"/>
        <p>下記QRコードを読み取りログイン画面にアクセスし、登録メールアドレスとパスワードを入力してマイページにログイン。マイページから各サービスをご利用ください。</p>
        <spacer :y="2"/>
        <div :class="$style.flex">
          <div>
            <!-- QR コードを読み取れない端末でも開けるよう URL を併記する -->
            <p :class="$style.qr"><a :href="`${baseURL}/login/`" target="_blank"><img :src="`https://api.qrserver.com/v1/create-qr-code//?size=120x120&data=${baseURL}/login/`"></a></p>
            <p :class="$style.url">{{ loginURL }}</p>
          </div>
          <p :class="$style.b">登録メールアドレス:{{ user.email }}</p>
        </div>
        <spacer :y="2"/>
        <ul :class="$style.lists">
          <li>メールアドレス（ID）はマイページの設定画面にて変更が可能です。閲覧可能なメールアドレスにご変更ください。</li>
          <li>マイページからLINE連携も可。テキスト健康相談の受付時やオンライン健康相談の予約完了時など自動通知が届きます。ぜひご活用ください。</li>
          <li>パスワードを忘れた場合はログイン画面の「パスワードをお忘れですか?」より登録メールアドレスをご入力ください。登録メールアドレス宛にパスワード再設定手続きのメールが届きます。メールが届かない場合は、迷惑メールフォルダもご確認ください。</li>
        </ul>
        <spacer :y="4"/>
        <div :class="[$style.c, $style.bdr]">
          <p>**個人情報のお取り扱いについて**</p>
          <p>本資料には、みなさまの個人情報が含まれます。<br>つきましては、以下の点にご留意いただき、適切なお取り扱いをお願いします。</p>
          <ul>
            <li>本資料の目的以外での利用はご遠慮ください。</li>
            <li>第三者への開示、漏洩、紛失等がないようご注意ください。</li>
            <li>本資料が不要になった際は、先生に返却するなど適切な方法で廃棄をお願いいたします。</li>
          </ul>
        </div>
      </div>
    </div>
    <spacer :y="1"/>
  </div>
</template>

<script>
// import { mapState } from 'vuex';
import Spacer from '@/views/components/Spacer.vue';
import cf from '@/mixins/commonFunctions.js';

export default {
  name: 'printActiveUser',
  mixins: [cf],
  components: {
    Spacer,
  },
  props: {
    user: {
      type: Object,
    },
  },
  data() {
    return {
    };
  },
  created() {
  },
  computed: {
    baseURL() {
      return `${location.protocol}//${location.host}`;
    },
    loginURL() {
      return `${this.baseURL}/login/`;
    },
  },
  methods: {
  },
};
</script>

<style lang="scss" module>
.wrapper {
  font-size: 13px;
  .c {
    text-align: center;
  }
  .underline {
    text-decoration: underline;
  }
  .b {
    font-weight: bold;
  }
  .flex {
    display: flex;
    align-items: center;
    > *:not(:first-child) {
      margin-left: 2em;
    }
  }
  .lists {
    li {
      position: relative;
      padding-left: 1em;
      &:before {
        content: '*';
        position: absolute;
        top: .3em;
        left: 0;
      }
    }
  }
  .url {
    margin-top: .3em;
    font-size: 11px;
    word-break: break-all;
  }
  .bdr {
    padding: 1em;
    border: 3px solid #333;
    > *:not(:first-child) {
      margin-top: 1em;
    }
  }
}
</style>
